require('jquery-countdown');

let $clock = $('.js-countdown');
$(document).ready(function () {
    if ($clock.length > 0) {
        let countdown = $clock.data('expire');

        $clock.countdown(countdown).on('update.countdown', function (event) {
            let weeks = parseInt(event.strftime('%-w'), 10);
            if (weeks > 0) {
                $clock.find('div[data-type="weeks"] .__digit').html(weeks < 10 ? ((weeks === 0 ? '' : '0') + weeks) : weeks);
                $clock.find('div[data-type="weeks"] .__label').html(event.strftime('Week%!w'));
            } else {
                $clock.find('div[data-type="weeks"]').remove();
            }

            let days = parseInt(event.strftime('%-d'), 10);
            $clock.find('div[data-type="days"] .__digit').html(days < 10 ? (days === 0 ? '00' : '0' + days) : days);
            $clock.find('div[data-type="days"] .__label').html(event.strftime('Day%!d'));

            $clock.find('div[data-type="hours"] .__digit').html(event.strftime('%H'));
            $clock.find('div[data-type="hours"] .__label').html(event.strftime('Hour%!H'));

            $clock.find('div[data-type="minutes"] .__digit').html(event.strftime('%M'));
            $clock.find('div[data-type="minutes"] .__label').html(event.strftime('Minute%!M'));

            $clock.find('div[data-type="seconds"] .__digit').html(event.strftime('%S'));
            $clock.find('div[data-type="seconds"] .__label').html(event.strftime('Second%!S'));

            $clock.removeClass('hide');
        });
    }
});
